// UploadBlobToS3.jsx
import { uploadData } from "aws-amplify/storage";
import { addFileToUploadedDocuments } from "../../graphqlCompnents/AWS/S3/addFileToUploadedDocuments";
import { v4 as uuidv4 } from "uuid";

export const uploadBlobToS3 = async (props) => {
  if (!props) {
    console.error("uploadBlobToS3: no props sent.");
    throw new Error("uploadBlobToS3: props are required");
  }

  try {
    const fileobj = props.file;
    const identityId = props.identityId;
    const filename = props.filename;
    const mimeType = props.filetype || "application/pdf";
    const bucket = props.bucket;

    if (!fileobj) throw new Error("uploadBlobToS3: file is required");
    if (!identityId) throw new Error("uploadBlobToS3: identityId is required");
    if (!filename) throw new Error("uploadBlobToS3: filename is required");
    if (!bucket) throw new Error("uploadBlobToS3: bucket is required");

    const fileKey = uuidv4() + ":" + filename; // short key

    const fileParams = {
      bucket,
      identityId,
      key: fileKey,
    };

    // Track in SpkUploadedDocumentsTbl
    await addFileToUploadedDocuments(fileParams);

    await uploadData({
      path: 'protected/' + identityId + '/' + fileKey,
      data: fileobj,
      options: {
        contentType: mimeType,
        bucket: {
          bucketName: bucket,
          region: 'us-east-1',
        },
      },
    }).result;

    // Return short key + identityId, caller can build full S3 key
    return {
      fileName: filename,
      identityId,
      key: fileKey, // IMPORTANT: this stays the short key
    };
  } catch (err) {
    console.error("uploadBlobToS3 error:", err);
    throw err;
  }
};